/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import toast from 'react-hot-toast';
import './OrderAdditionalInfo.scss';
import { Modal, Label } from '../../../../UiKit';
import Shimmer from 'sushiweb/Shimmer';
import { CommentsPop, UserEscalations } from '../../../popups';
import { AddManualTag, Tags } from '../../../commons';
import { dot } from '../../../../images/images';
import {
  ORDER_EVENTS,
  sendOrderApiEvents,
  sendOrderModalEvents,
} from '../../../../helpers/analytics/order.analytics';
import { orderModel } from '../../../../api';
import { PreviousIssues } from '../../../popups/PreviousIssuesModal/PreviousIssuesModal';
import {
  popUpClosedEvent,
  popUpOpenendEvent,
} from '../../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../../analytics/constants';
import ChatSummaryBtn from '../../../popups/ChatSummary/ChatSummaryBtn';

const dashboardMode = window.dashboard.mode;
export const SMARTPLUG = 'smartplug';

export default class OrderAdditionalInfo extends Component {
  render() {
    const { orderBasicInfo } = this.props;
    return (
      <div className='additionalInfoContainer'>
        {!orderBasicInfo ? (
          <Shimmer height='6rem' width='100%' />
        ) : (
          <OrderAdditionalInfoComp {...this.props} />
        )}
      </div>
    );
  }
}

class OrderAdditionalInfoComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommemntsPopup: false,
      refund_summary: null,
      transactionsLoading: false,
      showEscalationPopup: false,
      showDominosPopup: false,
      dominosDetails: null,
    };
  }

  componentDidMount = () => {
    this.getTags();
    this.fetchTransactionDetails();
  };

  showCommemntsPopup = () => {
    const { orderId, userId } = this.props;
    popUpOpenendEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.COMMENTS,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.customer_id]: userId,
    });
    this.setState({
      showCommemntsPopup: true,
    });
  };

  closeCommemntsPopup = () => {
    const { orderId, userId } = this.props;
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.COMMENTS,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.customer_id]: userId,
    });
    this.setState({
      showCommemntsPopup: false,
    });
  };

  getTranscrtionStr = (refund_summary) => {
    if (this.state.transactionsLoading) return '';
    let txnStr = <span className='colorGreen'>Transactions</span>;
    if (refund_summary?.is_refunded) {
      txnStr = (
        <span className='red'>{refund_summary?.display_total} refunded</span>
      );
    }
    return txnStr;
  };

  getTags = () => {
    const { orderId, getTags } = this.props;
    const querryParams = {};
    querryParams['order_id'] = orderId;
    getTags(querryParams);
  };

  fetchTransactionDetails() {
    const { setTransactionDetails } = this.props;
    this.setState({
      transactionsLoading: true,
    });
    orderModel
      .getTransactionsDetails({
        order_id: this.props.orderId,
        cart_id: this.props.cartId,
        customer_id: this.props.userId,
      })
      .then((res) => {
        setTransactionDetails(res);
        this.setState({
          refund_summary: res?.refund_summary,
          transactionsLoading: false,
        });
      });
  }

  selectedManualTag = (selectedManualTag, url) => {
    const { addManualTag, orderId, userId } = this.props;
    const data = {};
    data['order_id'] = orderId;
    data['tag_id'] = selectedManualTag;
    addManualTag(url, data, userId)
      .then((res) => {
        if (!res || (res && res.isError === true)) {
          sendOrderApiEvents(
            ORDER_EVENTS.ADD_MANUAL_TAG_FAILURE,
            orderId,
            userId,
          );
          toast.error(res.message ?? 'Oooopss! something went wrong!');
          return;
        }
        sendOrderApiEvents(
          ORDER_EVENTS.ADD_MANUAL_TAG_SUCCESS,
          orderId,
          userId,
          { tag: String(selectedManualTag) },
        );
        toast.success(res.message ?? 'Tag successfully added!');
        this.getTags();
      })
      .catch((error) => {
        sendOrderApiEvents(
          ORDER_EVENTS.ADD_MANUAL_TAG_FAILURE,
          orderId,
          userId,
        );

        toast.error('Oooopss! something went wrong!');
      });
  };

  showEscalations = () => {
    const { orderId, userId } = this.props;
    sendOrderModalEvents(ORDER_EVENTS.ESCALATION_MODAL_OPEN, orderId, userId);
    this.setState({
      showEscalationPopup: true,
    });
  };

  closeEscalationPopup = () => {
    const { orderId, userId } = this.props;
    sendOrderModalEvents(ORDER_EVENTS.ESCALATION_MODAL_CLOSE, orderId, userId);
    this.setState({
      showEscalationPopup: false,
    });
  };

  render() {
    const {
      orderBasicInfo,
      comments,
      orderId,
      userId,
      cartId,
      tags,
      getTransactionsDetails,
      openDominosPopup,
    } = this.props;

    const { refund_summary } = this.state;
    const { order } = orderBasicInfo;
    const { showCommemntsPopup, showEscalationPopup } = this.state;
    const commentsCount = comments ? comments.length : 0;
    if (!order) return null;
    const {
      manual_tags,
      has_email_escalations,
      show_dominos_ticket,
      dominos_ticket_details,
    } = order;

    return (
      <div
        className={`tw-flex ${
          dashboardMode === 'smartplug' ? 'tw-items-center' : 'tw-items-start'
        } tw-w-full tw-justify-between`}
      >
        <div
          className={`tw-flex ${
            dashboardMode === 'smartplug' ? 'tw-items-center' : 'tw-items-start'
          } tw-gap-2`}
        >
          <div
            className={`tw-flex ${
              dashboardMode === 'smartplug'
                ? 'tw-items-center'
                : 'tw-items-start'
            } tw-gap-4 tw-flex-wrap`}
          >
            <PreviousIssues orderId={orderId} />

            <p
              className='comments tw-whitespace-nowrap'
              onClick={this.showCommemntsPopup.bind(this)}
            >
              <span className='colorGreen'>Comments ({commentsCount})</span>
            </p>

            <p
              className='paymentDetails tw-cursor-pointer'
              onClick={() => {
                popUpOpenendEvent({
                  event_type: EventType.CLICK,
                  feature_name: FeatureName.TRANSACTIONS,
                  [MetricsForJumboEvent.order_id]: orderId,
                  [MetricsForJumboEvent.customer_id]: userId,
                });
                getTransactionsDetails();
              }}
            >
              <span className='colorGreen'>
                {this.getTranscrtionStr(refund_summary)}
              </span>
            </p>

            {show_dominos_ticket && dominos_ticket_details && (
              <React.Fragment>
                <p
                  className='dominosTicket pointer'
                  onClick={() => openDominosPopup(dominos_ticket_details.url)}
                >
                  <span className='bold'>{dominos_ticket_details.name}</span>
                </p>
              </React.Fragment>
            )}

            {has_email_escalations && (
              <p
                className='iconMarginR escalation'
                onClick={this.showEscalations}
              >
                <Label
                  showIcon={false}
                  icon={dot}
                  pos='left'
                  title='Email escalations'
                  bgColor='#EBFFEF'
                  textColor='#24963F'
                  padding='0.5rem 0.6rem'
                  fontWeight='500'
                />
              </p>
            )}
          </div>

          <div className='tw-flex tw-items-center tw-gap-4 tw-h-full tw-flex-wrap'>
            {tags && <Tags orderId={orderId} tags={tags} />}
            {manual_tags && (
              <AddManualTag
                manualTags={manual_tags}
                onSelectTag={this.selectedManualTag}
                addedTags={tags}
                orderId={orderId}
                userId={userId}
              />
            )}
          </div>
        </div>
        <div>
          {dashboardMode === SMARTPLUG &&
            orderBasicInfo?.order?.show_chat_summary && (
              <ChatSummaryBtn
                orderId={orderId}
                userId={userId}
                cartId={cartId}
                mode={SMARTPLUG}
              />
            )}
        </div>

        {showCommemntsPopup && (
          <Modal
            isVisible={showCommemntsPopup}
            title='Comments'
            type='large'
            handleClose={this.closeCommemntsPopup.bind(this)}
            component={<CommentsPop comments={comments} />}
          />
        )}

        {showEscalationPopup && (
          <Modal
            isVisible={showEscalationPopup}
            title='Email escalations for the user'
            type='large'
            handleClose={this.closeEscalationPopup.bind(this)}
            component={<UserEscalations orderId={orderId} />}
          />
        )}
      </div>
    );
  }
}
